import HolidayApplicationPage from './HolidayApplicationPage';

export default HolidayApplicationPage;
